import React from 'react';
import styles from './InputComponents.module.css';

const SelectInput = ({ question, value, error, onChange, isSubmitted }) => {
    return (
        <div className={styles.questionWrapper}>
            <label className={styles.questionLabel}>
                {question.text}
                {question.required && <span className={styles.required}>*</span>}
            </label>
            {question.annotation && (
                <span className={styles.annotation}>{question.annotation}</span>
            )}
            <select
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                disabled={isSubmitted}
                className={`${styles.select} ${error ? styles.inputError : ''}`}
            >
                <option value="">-- Select an option --</option>
                {question.options?.map((option, idx) => (
                    <option key={idx} value={option}>
                        {option}
                    </option>
                ))}
            </select>
            {error && <span className={styles.errorText}>{error}</span>}
        </div>
    );
};

export default SelectInput;